import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  industryData: localStorage.getItem("industryData")
    ? JSON.parse(localStorage.getItem("industryData"))
    : null,
  financialData: localStorage.getItem("financialData")
    ? JSON.parse(localStorage.getItem("financialData"))
    : null,
  companyData: localStorage.getItem("companyData")
    ? JSON.parse(localStorage.getItem("companyData"))
    : null,
  uploadData: localStorage.getItem("uploadData")
    ? JSON.parse(localStorage.getItem("uploadData"))
    : null,
  companyAddress: localStorage.getItem("companyAddress")
    ? JSON.parse(localStorage.getItem("companyAddress"))
    : null,
  authorizedSignatory: localStorage.getItem("authorizedSignatory")
    ? JSON.parse(localStorage.getItem("authorizedSignatory"))
    : null,
  currentEditingCompany: localStorage.getItem("currentEditingCompany")
  ? JSON.parse(localStorage.getItem("currentEditingCompany"))
  :null,
  insuranceData: null,
};

const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    setIndustryData: (state, action) => {
      state.industryData = action.payload;
      localStorage.setItem("industryData", JSON.stringify(action.payload));
    },
    setCompanyData: (state, action) => {
      state.companyData = action.payload;
      localStorage.setItem("companyData", JSON.stringify(action.payload));
    },
    setUploadData: (state, action) => {
      state.uploadData = action.payload;
      localStorage.setItem("uploadData", JSON.stringify(action.payload));
    },
    setFinancialData: (state, action) => {
      state.financialData = action.payload;
      localStorage.setItem("financialData", JSON.stringify(action.payload));
    },
    setUserSelectedCompany: (state, action) => {
      state.companySelectedByUser = action.payload;
    },
    setCompanyAddress: (state, action) => {
      state.companyAddress = action.payload;
      localStorage.setItem("companyAddress", JSON.stringify(action.payload));
    },
    setAuthorizedSignatory: (state, action) => {
      state.authorizedSignatory = action.payload;
      localStorage.setItem(
        "authorizedSignatory",
        JSON.stringify(action.payload)
      );
    },
    setInsuranceData: (state, action) => {
      state.insuranceData = action.payload;
      localStorage.setItem("insuranceData", JSON.stringify(action.payload));
    },
    setCurrentEditingCompany: (state, action) => {
      state.currentEditingCompany = action.payload;
      localStorage.setItem(
        "currentEditingCompany",
        JSON.stringify(action.payload)
      );
    },
    clearSignatoryAddress: (state) => {
      state.companyAddress = null;
      state.authorizedSignatory = null;
      state.companyData = null;
      state.industryData = null;
      localStorage.removeItem("companyAddress");
      localStorage.removeItem("authorizedSignatory");
      localStorage.removeItem("companyData");
      localStorage.removeItem("industryData");
    },
  },
});

export const {
  setInsuranceData,
  setFinancialData,
  setUploadData,
  setIndustryData,
  setCompanyData,
  setUserSelectedCompany,
  setAuthorizedSignatory,
  setCompanyAddress,
  setCurrentEditingCompany,
  clearSignatoryAddress,
} = companySlice.actions;

export default companySlice.reducer;
